export default __webpack_public_path__ + "img/icon-error.45c0dce9.png";